import { string, email } from '../../../helpers/validations';

export const validationMap = {
  "email": email,
  "roleId": string
}